/* eslint-disable max-len */
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';
import { GeneralService } from '~/settings/service/GeneralService';

export const FONT_SIZE_STYLE = {
  FONT_LARGE: 'font_large',
  FONT_MEDIUM: 'font_medium',
};

export class GeneralBiz {
  static async getAutoTranslateOption() {
    const data = await GeneralService.initAutoTrans();
    return {
      selected: data.selected,
      list: data.list,
    };
  }

  static getSendMsgShortCutOption() {
    let shortcuts = CommonService.getOptionValue(UserOptionName.Send_Msg_Key);
    if (shortcuts == null || shortcuts == '') {
      shortcuts = 'Enter';
    }
    return shortcuts;
  }

  static getFontSizeOption() {
    const font_size = CommonService.getOptionValue(
      UserOptionName.FONT_SIZE_STYLE,
    );
    return font_size;
  }

  static async save(params) {
    let shortcuts = params.sendKey || 'Enter';
    CommonService.setOptionValue(UserOptionName.Send_Msg_Key, shortcuts, false);

    let autoTransalte = params.translate;
    CommonService.setOptionValue(
      UserOptionName.Smart_Translate,
      autoTransalte,
      false,
    );

    let fontsize = params.fontsize;
    if (fontsize) {
      CommonService.setOptionValue(
        UserOptionName.FONT_SIZE_STYLE,
        fontsize,
        false,
      );
    }

    const resp = await CommonService.save(true);
    if (!resp.data || (resp.data && resp.data.code !== 200)) {
      return false;
    } else {
      return true;
    }
  }
}
